// eslint-disable-next-line import/no-named-as-default
import { api } from './base.service';

export const getAllSectors = () => {
  return api().get('/api/sectors');
};
